import styled, { css } from "styled-components";
import { Button } from "react-bootstrap";

export const Container = styled.div`
  ${({ theme, marginTop }) => css`
    margin-bottom: 35px;
    height: 60px;
    width: 100%;
    background-color: ${theme.colors.gstWhite};
    @media only screen and (max-width: 375px) {
      width: 100%;
      margin-top: ${marginTop ? marginTop : 0}%;
    }
  `}
`;

export const SignUpSection = styled.section`
  margin-top: 40px;
  @media only screen (min-width: 768px) and (max-width: 1199px) {
    width: 90%;
    margin: 0 auto;
  }
`;

export const ContainerRight = styled.div`
  width: 45%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  left: 50px;
  padding: 10px;
  & h3 {
    font-size: 46px;
    margin: 0 0 30px;
    font-weight: 600;
  }
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
`;

export const FieldContainerLeft = styled.div`
  width: 100%;
  vertical-align: top;
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
  @media only screen and (max-width: 1730px) {
    width: 100%;
    display: flex;
  }
  @media only screen and (max-width: 375px) {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
`;
export const FirstNameInput = styled.div`
  width: 45%;
  display: inline-block;
  margin-right: 56px;
  @media only screen and (max-width: 375px) {
    width: 95%;
    margin: 0;
  }
`;
export const LastNameInput = styled.div`
  width: 45%;
  display: inline-block;
  @media only screen and (max-width: 375px) {
    width: 95%;
  }
`;

export const SignUpTitle = styled.h3`
  font-family: "StagSansWeb-Medium";
  font-size: 46px;
  line-height: 55px;
  font-weight: 500;
  margin: 0 0 30px;
  font-weight: 500;
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
`;

export const SignupForm = styled.form`
  ${({ theme }) => css`
    background-color: ${theme.colors.gstWhite};
    padding: 32px;
    & h2 {
      font-size: 1.7rem;
      margin: 0 0 16px;
      color: ${theme.colors.black};
    }
    & input {
      margin-bottom: 15px;
      border-radius: 4px;
    }
    @media only screen and (max-width: 767px) {
      padding: 20px;
    }
  `}
`;

export const ButtonClass = styled.div`
  margin-top: 1rem;
  & p {
    font-size: 0.75rem;
    width: 500%;
    padding-top: 15px;
    margin: 0 2% 0 0px;
    color: black;
    font-weight: 400;
    @media only screen and (max-width: 767px) {
      width: 100%;
      margin: 0 0 5% 0;
    }
  }
  & a {
    color: #66d7d1;
  }
  & a:hover {
    color: #0056b3;
    text-decoration: underline;
  }
`;

export const AlreadyRegistered = styled.div`
  margin-top: 1.5rem;
  font-size: 0.875rem;
  text-align: right;
  & a {
    color: #66d7d1;
    text-decoration: none;
  }
`;

export const ButtonContainer = styled.div`
  position: relative;
  left: 0;
  top: 5px;
  width: 50%;
  height: 55px;
  font-size: 16px;
  font-weight: 600;
  @media only screen and (max-width: 1730px) {
    width: 100%;
    display: flex;
  }
`;

export const PasswordInfo = styled.div`
  position: relative;
  top: -70px;
  float: right;
  right: 4px;
`;

export const EyeContainer = styled.div`
  position: relative;
  top: -70px;
  float: right;
  right: 55px;
  font-size: 20px;
  &:hover {
    color: #66d7d1;
  }
`;

export const Eye = styled.div``;

export const SignupButton = styled(Button)`
  width: 100%;
`;
